//import Image from "next/image";
import Link from "next/link";

const TopHeader = () => {
  return (
    <div className="top-header flex flex-col items-center">
      <Link href="/">
        <img
          src="/images/CFOW_new_logo.avif"
          alt="CFOW Logo"
          width={200}
          height={45}
          className="w-30 h-auto md:w-58 md:h-auto" // Responsive sizes
      
        />
      </Link>
    </div>
  );
};

export default TopHeader;